import { gql } from "@/services/httpAdapter";

const resolveuserProfileSubscriptionPipeline = (_id: string) => [
	{
		context: "onUpdateUser",
		query: gql`
			subscription onUpdateUser($_id: ID!) {
				onUpdateUser(_id: $_id) {
					_id
					employeeId
					username
					communications {
						acceptsTxt
						communicationType
						usage
						value
					}
				}
			}
		`,
		variables: {
			_id,
		},
	},
];

export { resolveuserProfileSubscriptionPipeline };
